// extracted by mini-css-extract-plugin
export default {"error":"error_error__n5c5r"};